import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchGoalsIfNeeded } from '../actions/goals';
import Goals from '../components/Goals';

const mapStateToProps = state => ({
  fetching: state.goals.fetching,
  invertedTheme: state.ui.invertedTheme,
  goals: state.goals.goals,
  posting: state.goals.posting
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      fetchGoals: fetchGoalsIfNeeded,
      postGoalAction: id => {
        return { type: 'POSTING_GOAL_ACTION', id };
      },
      donePostingGoalAction: () => {
        return { type: 'DONE_POSTING_GOAL_ACTION' };
      }
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Goals);



// WEBPACK FOOTER //
// ./src/containers/GoalsContainer.js